import { render, staticRenderFns } from "./UpboxList.vue?vue&type=template&id=5640f48f&scoped=true"
import script from "./UpboxList.vue?vue&type=script&lang=js"
export * from "./UpboxList.vue?vue&type=script&lang=js"
import style0 from "./UpboxList.vue?vue&type=style&index=0&id=5640f48f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5640f48f",
  null
  
)

export default component.exports